import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthProvider.component";
import { useCognitoAuth } from "frontend/src/components/CognitoAuth";

export default function SecureRoute({
  children,
  useCognito = false,
}: {
  children: React.ReactElement | null;
  useCognito?: boolean;
}) {
  // Cognito auth flow
  if (useCognito) {
    const { isAuthenticated, isLoading } = useCognitoAuth();

    if (isLoading) return null;
    if (!isAuthenticated) return <Navigate to="/login" />;

    return children;
  }

  // Okta auth flow
  const { auth, isLoading } = useContext(AuthContext);

  if (isLoading) return null;

  if (!auth) return <Navigate to="/login" />;

  return children;
}
